import {disableScroll, enableScroll} from './toggleScroll';

function redirectModal() {
    const redirectModal = document.querySelector('[data-redirect-modal]');
    if (!redirectModal) return;

    if (sessionStorage.getItem('show-redirect-modal')) return;

    initializeModal();

    function showModal() {
        redirectModal.classList.add('active');
        disableScroll();
    }

    function hideModal() {
        sessionStorage.setItem('show-redirect-modal', 'false');
        redirectModal.classList.remove('active');
        enableScroll();
    }

    function initializeModal() {
        setTimeout(() => {
            showModal();
        }, 3000);

        redirectModal.addEventListener('click', function ({target}) {
            if (target.hasAttribute('data-modal-btn')) {
                hideModal();
            }
        });

        document.addEventListener('keydown', handleKeydown);
    }

    function handleKeydown({key}) {
        if (key === 'Escape' && redirectModal.classList.contains('active')) {
            hideModal();
            document.removeEventListener('keydown', handleKeydown);
        }
    }
}

export default redirectModal;



// WEBPACK FOOTER //
// ./scripts/modules/redirectModal.js